import { TABLE_API } from "../../api/table";

const table = {
    namespaced: true,
    state: {
        tables: [],
        totalTable: 0,
    },
    getters: {},
    mutations: {
        SET_TABLES: (state, payload) => {
            state.tables = payload;
        },
        SET_TOTAL_TABLE: (state, payload) => {
            state.totalTable = payload;
        },
    },
    actions: {
        async syncTables({ commit }, delay = 1000) {
            setTimeout(async () => {
                const { total, tables } = await TABLE_API.listTables({
                    offset: 0,
                    limit: 1000,
                });
                commit("SET_TABLES", tables);
                commit("SET_TOTAL_TABLE", total);
            }, delay);
        },

        async fetchCustomerTables({ commit }, queries) {
            const { total, tables } = await TABLE_API.listTables();
            commit("SET_TABLES", tables);
            commit("SET_TOTAL_TABLE", total);
            return { total, tables };
        },
        async deleteCustomerTable({ state, commit }, tableId) {
            await TABLE_API.deleteTable(tableId);
            commit(
                "SET_TABLES",
                state.tables.filter((table) => table._id !== tableId)
            );
            commit("SET_TOTAL_TABLE", state.totalTable - 1);
        },
    },
};

export default table;
